import React from 'react';
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import Paragraph from '@src/stories/elements/Paragraph/Paragraph';
import { Image } from "@project-stories/elements/Image/Image";

import './MeetTheTeam.scss';

export const MeetTheTeam = ({ settings, blocks }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  return (
    <div className="flex flex-col md:flex-row items-stretch"
      style={{
        marginRight: `-${isMobile ? settings.section.padding_right_mobile : settings.section.padding_right_desktop}px`,
      }}
    >
      <div className="bio-block max-lg:hidden relative flex flex-col">
        <div className="flex flex-col w-[440px] pr-6 py-6 gap-2 ">
          <div className="flex-1 flex flex-col h-full">
            <div className="flex-1 rte b_small_light" dangerouslySetInnerHTML={{ __html: settings.section.bio }} />
          </div>
        </div>
      </div>
      <div className="flex w-full">
        <div className="grid-responsive">
          {blocks.map((block) => (
            <div key={block.id}
              className={`space-y-6
                pt-[${block.settings.padding_top_mobile}px] lg:pt-[${block.settings.padding_top_desktop}px]
                pb-[${block.settings.padding_bottom_mobile}px] lg:pb-[${block.settings.padding_bottom_desktop}px]
                px-[${block.settings.padding_left_right_mobile}px]  lg:px-[${block.settings.padding_left_right_desktop}px]
              `}
            >
              <Image classes='w-full' imageUrl={block.settings.image} alt={block.settings.title} />
              <div className="space-y-3">
                <h3 className={`${isMobile ? block.settings.title_font_style_mobile : block.settings.title_font_style}`}>
                  {block.settings.title}
                </h3>
                <div className={`${isMobile ? block.settings.subtitle_font_style_mobile : block.settings.subtitle_font_style}`}>
                  {block.settings.subtitle}
                </div>
              </div>
              <Paragraph
                text={block.settings.content}
                type={`${isMobile ? block.settings.content_font_style_mobile : block.settings.content_font_style} max-w-full`}
                maxChars={isMobile ? block.settings.max_chars_mobile : block.settings.max_chars}
                shouldTruncateText={true}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MeetTheTeam;